function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M186 93C186 144.362 144.362 186 93 186C41.6375 186 0 144.362 0 93C0 41.6375 41.6375 0 93 0C144.362 0 186 41.6375 186 93ZM181 93C181 141.601 141.601 181 93 181C44.3989 181 5 141.601 5 93C5 44.3989 44.3989 5 93 5C141.601 5 181 44.3989 181 93Z",
  fill: "#F9F9F9"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M63.891 107.871C40.8841 114.24 25 127.8 25 143.5C25 165.315 55.6685 183 93.5 183C131.332 183 162 165.315 162 143.5C162 127.626 145.762 113.939 122.342 107.661C114.556 114.712 104.273 119 93 119C81.8387 119 71.648 114.797 63.891 107.871Z",
  fill: "#F9F9F9"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M132 75C132 96.5391 114.539 114 93 114C71.4609 114 54 96.5391 54 75C54 53.4609 71.4609 36 93 36C114.539 36 132 53.4609 132 75Z",
  fill: "#F9F9F9"
});

var SvgAvatar = function SvgAvatar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 186,
    viewBox: "0 0 186 186",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAvatar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/avatar.412ccc84.svg";
export { ForwardRef as ReactComponent };